export enum OrderItemType {
    Product = 'product',
    Configuration = 'configuration',
    Custom = 'custom',
}